import './styles.scss'

import React from 'react'
import { Button } from 'reactstrap'

/**
 *
 * @param {Object} props
 * title: string
 * text: string
 * textBtn: string
 * clickBtn: Function
 * linkBtn: Function
 * imgBanner: string
 */
function BannerInfo({ props }) {
  const handleClick = () => {
    props.handleClick(props)
  }

  return (
    <div className='banner-info-overview'>
      <div className='banner-body'>
        <h1 className='banner-title'>{props.title}</h1>
        <p className='banner-text'>{props.text}</p>
        <div className='space'></div>
        <Button outline color='muted btn-lg' onClick={handleClick}>
          {props.textBtn}
        </Button>
      </div>

      <div className='banner-img'>
        <img src={props.imgBanner} alt="banner"></img>
      </div>
    </div>
  )
}

export default BannerInfo
